import { component } from 'picoapp';
import { clear } from 'utils/clear';

export default component((node) => {
  const productList = node.querySelector<HTMLElement>('[data-product-list]');
  let viewPrevBtn = node.querySelector<HTMLElement>('[data-view-prev-btn]');
  let viewMoreBtn = node.querySelector<HTMLElement>('[data-view-more-btn]');
  let paginationNav = node.querySelector<HTMLElement>('[data-pagination-nav]');
  const productCount = node.querySelector<HTMLElement>('[data-product-count]');
  const filterForm = node.querySelector<HTMLFormElement>('[data-filter-form]');
  const filterDrawer = document.querySelector<HTMLFormElement>('[data-id="filterDrawer"]');
  const filterApply = document.querySelectorAll<HTMLElement>('[data-filter-apply]');
  const detailsTags = [...node.querySelectorAll<HTMLDetailsElement>('[data-filter-group]')];

  document.addEventListener('click', (e) => {
    if (!detailsTags.some((f) => f.contains(e.target as HTMLElement))) {
      detailsTags.forEach((f) => f.removeAttribute('open'));
    }
  });

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      detailsTags.forEach((f) => f.removeAttribute('open'));
    }
  });
  // Pagination
  interface CollectionConfig {
    sectionId: string,
  }

  interface ProductListConfig {
    pages: number,
  }

  const collectionConfig: CollectionConfig = JSON.parse(node.dataset.config);
  const { sectionId } = collectionConfig;

  const fetchSection = async (url?: string) => {
    let fetchUrl = `${window.location.pathname}?${new URLSearchParams(new FormData(filterForm) as any).toString()}`;

    if (url) {
      fetchUrl = url;
    }

    window.history.replaceState({}, '', fetchUrl);
    const appendFetchUrl = new URL(window.location.href);

    appendFetchUrl.searchParams.set('section_id', sectionId);

    const response = await fetch(appendFetchUrl.toString(), {
      method: filterForm.method,
    });
    const markup = await response.text();

    const container = document.createElement('div');
    container.innerHTML = markup;

    return container;
  };

  const loadNextPage = async () => {
    const url = new URL(window.location.href);
    const nextPage = parseInt(url.searchParams.get('page') || '1', 10) + 1;

    url.searchParams.set('page', nextPage.toString());

    const section = (await fetchSection(url as any));
    const list = section.querySelector<HTMLElement>('[data-product-list]');
    const html = list.innerHTML;
    const configElement = section.querySelector('[data-product-list-config]');

    productList.insertAdjacentHTML('beforeend', html);

    const productListConfig: ProductListConfig = JSON.parse(configElement.textContent);
    const { pages } = productListConfig;

    if (nextPage >= pages) {
      viewMoreBtn.hidden = true;
      paginationNav.hidden = true;
    }
  };

  const loadPreviousPages = async () => {
    const url = new URL(window.location.href);
    const currentPage = parseInt(url.searchParams.get('page'), 10);

    const fetches = [];

    for (let page = 1; page < currentPage; page += 1) {
      url.searchParams.set('page', page.toString());
      fetches.push(fetchSection(url as any));
    }

    const html = (await Promise.all(fetches)).map((container) => (
      container.querySelector('[data-product-list]')
    )).map((list) => (
      list.innerHTML
    )).join('');

    productList.insertAdjacentHTML('afterbegin', html);

    if (viewPrevBtn) viewPrevBtn.hidden = true;
  };

  function renderSection(container: HTMLElement) {
    const newProductList = container.querySelector('[data-product-list]');
    const newViewPrevBtn = container.querySelector('[data-view-prev-btn]');
    const newViewMoreBtn = container.querySelector('[data-view-more-btn]');
    const newPaginationNav = container.querySelector('[data-pagination-nav]');
    const newProductCount = container.querySelector('[data-product-count]');

    if (productList && newProductList) {
      productList.innerHTML = newProductList.innerHTML;
    }

    if (productCount && newProductCount) {
      productCount.innerHTML = newProductCount.innerHTML;
    }

    if (viewPrevBtn && newViewPrevBtn) {
      viewPrevBtn.replaceWith(newViewPrevBtn);
      viewPrevBtn = node.querySelector<HTMLElement>('[data-view-prev-btn]');
      viewPrevBtn?.addEventListener('click', loadPreviousPages);
    }

    if (paginationNav && newPaginationNav) {
      paginationNav.replaceWith(newPaginationNav);
      paginationNav = node.querySelector<HTMLElement>('[data-pagination-nav]');
    }

    if (viewMoreBtn && newViewMoreBtn) {
      viewMoreBtn.replaceWith(newViewMoreBtn);
      viewMoreBtn = node.querySelector<HTMLElement>('[data-view-more-btn]');
      viewMoreBtn?.addEventListener('click', loadNextPage);
    }
  }

  function activeFilters(filterFormTarget) {
    const activeInputs = filterFormTarget.querySelectorAll('input[type="checkbox"]:checked') as NodeListOf<HTMLInputElement>;
    const activeInputElements = Array.from(activeInputs).map((input) => {
      const element = document.createElement('button');
      element.type = 'button';
      element.classList.add('active-filters-container__item');
      element.innerHTML = `${input.value}<span>×</span>`;
      element.addEventListener('click', () => {
        input.checked = false;
        input.dispatchEvent(new Event('change'));
        element.remove();
        filterForm.dispatchEvent(new Event('change'));
      });
      return element;
    });

    const activeFiltersContainer = document.querySelector<HTMLElement>('[data-active-filters]');
    activeFiltersContainer.innerHTML = '';

    activeInputElements.forEach((element) => {
      activeFiltersContainer?.appendChild(element);
    });

    if (activeInputElements.length > 0) {
      const filterProductsCount = document.createElement('p');
      filterProductsCount.classList.add('active-filters-container__count-item');
      filterProductsCount.innerHTML = productCount.innerHTML;
      activeFiltersContainer?.appendChild(filterProductsCount);
    }

    if (activeInputElements.length > 1) {
      const clearAll = document.createElement('button');
      clearAll.type = 'button';
      clearAll.classList.add('active-filters-container__delete-item');
      clearAll.innerHTML = window.theme.strings.filterDeleteAll;
      clearAll.addEventListener('click', () => {
        activeInputElements.forEach((element) => {
          element.remove();
        });
        activeInputs.forEach((input) => {
          input.checked = false;
          input.dispatchEvent(new Event('change'));
        });
        filterForm.dispatchEvent(new Event('change'));
      });
      activeFiltersContainer?.appendChild(clearAll);
    }
  }

  const checkWindowSize = () => {
    if (window.innerWidth < 768) {
      activeFilters(filterDrawer);
    } else {
      activeFilters(filterForm);
    }
  };
  window.addEventListener('resize', checkWindowSize);
  checkWindowSize();

  if (filterForm) {
    filterForm.addEventListener('change', async (e) => {
      const target = e.target as HTMLInputElement;
      const closestTarget = target.closest<HTMLFormElement>('[data-filter-form]');

      if (closestTarget) {
        e.preventDefault();
        const container = await fetchSection();
        renderSection(container);
      }
      checkWindowSize();
    });
  }

  const renderSortedProducts = async (url: URL) => {
    const list = (await fetchSection(url as any)).querySelector<HTMLElement>('[data-product-list]');
    const count = (await fetchSection(url as any)).querySelector<HTMLElement>('[data-product-count]');
    const html = list.innerHTML;

    clear(productList);

    await loadPreviousPages();
    productList.insertAdjacentHTML('beforeend', html);
    if (productCount) {
      productCount.innerHTML = count.innerHTML;
    }
  };

  document.addEventListener('collection:sort:apply', (event: CustomEvent) => {
    const { url } = event.detail;
    renderSortedProducts(url);
  });

  viewPrevBtn?.addEventListener('click', loadPreviousPages);
  viewMoreBtn?.addEventListener('click', loadNextPage);

  filterApply.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const container = await fetchSection();
      renderSection(container);
      activeFilters(filterDrawer);
    });
  });
});
